import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { useApiRequests, useUser } from 'hooks';
import { IUserContext } from 'context';
import { TokenResponse } from 'types';

export function ConfirmEmailPage() {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation('auth');
  const { confirmEmail } = useApiRequests();
  const { login }: IUserContext = useUser();

  const search = useLocation().search;
  const navigate = useNavigate();

  const [operationFinished, setOperationFinished] = useState<boolean>(false);

  useEffect(() => {
    const userId = new URLSearchParams(search).get('userId');
    const code = new URLSearchParams(search).get('code')?.replaceAll(' ', '+');

    if (userId && code) {
      confirmEmail(userId, code)
        .then((tokenResponse: TokenResponse) => {
          login(tokenResponse);
          enqueueSnackbar(t('emailConfirmed'), { variant: 'info' });
        })
        .catch((error) => {
          enqueueSnackbar(t('emailConfirmationError', { message: error.message }), { variant: 'error' });
        })
        .finally(() => {
          setOperationFinished(true);
        });
    }
  }, [confirmEmail, enqueueSnackbar, login, search, t]);

  useEffect(() => {
    if (operationFinished) {
      setTimeout(() => {
        navigate('/register?step=createRoom');
      }, 2000);
    }
  }, [navigate, operationFinished]);

  return <></>;
}
